import { PhotoFigure } from "@/components/photo-figure";
import { CountUp } from "@/components/count-up";
import { SectionMark } from "@/components/section-mark";
import portrait from "@/assets/sylwia-portrait.jpg.asset.json";
import portraitMobile from "@/assets/sylwia-portrait-mobile.jpg";
import portraitTablet from "@/assets/sylwia-portrait-tablet.jpg";

export function HeroSection() {
  return (
    <section id="start" className="border-b border-ink/10">
      <div className="grid md:grid-cols-[1.08fr_0.92fr]">
        <div className="border-b border-ink/10 px-6 py-12 md:border-b-0 md:border-r md:px-10 md:py-16 lg:px-12">
          <SectionMark number="01" label="Psychologia · Biznes · Relacje" />

          <h1 className="serif-display mt-8 max-w-[18ch] text-balance">
            <span className="italic text-coral-text">Są decyzje</span>, których nie da się omówić z zespołem czy bliskimi.
          </h1>

          <p className="mt-6 max-w-xl font-serif text-xl font-light italic leading-snug text-ink-soft md:text-2xl">
            Nie musisz zostawać z nimi sam na sam.
          </p>

          <p className="mt-5 text-xs font-medium uppercase tracking-[0.18em] text-ink-soft sm:text-sm">
            Psycholog dla liderów. Wystąpienia i mastermind
          </p>


          <div className="mt-10 h-px w-16 bg-coral/60" />

          <p className="mt-10 max-w-2xl border-l-2 border-coral pl-6 text-lg leading-relaxed text-ink/90 md:text-xl">
            Jestem psychologiem, psychoterapeutką i przedsiębiorczynią. Zarządzam organizacją
            obejmującą 30 placówek i około 300 osób. Znam odpowiedzialność lidera z obu stron,
            gabinetu i własnego biznesu.
          </p>

        </div>


        <div className="relative aspect-[4/5] bg-steel-soft sm:aspect-[16/10] md:aspect-auto md:min-h-[34rem]">
          <PhotoFigure
            src={portrait.url}
            alt="Sylwia Sitkowska, psycholog, psychoterapeutka i przedsiębiorczyni"
            figureClassName="h-full"
            className="h-full"
            imgClassName="h-full w-full object-cover object-[52%_18%] md:min-h-[34rem] md:object-[50%_28%]"
            width={1320}
            height={1372}
            srcSet={`${portraitTablet} 1024w, ${portrait.url} 1320w`}
            sizes="(max-width: 1023px) 50vw, 42vw"
            pictureSources={[
              { srcSet: portraitMobile, media: "(max-width: 767px)" },
              { srcSet: portraitTablet, media: "(min-width: 768px) and (max-width: 1023px)" },
            ]}
            priority
          />
          <div
            aria-hidden="true"
            className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-b from-transparent to-surface md:hidden"
          />
          <div
            aria-hidden="true"
            className="absolute -bottom-4 left-6 hidden h-24 w-24 bg-coral/15 mix-blend-multiply md:block"
          />
        </div>

      </div>

      <div className="stagger grid grid-cols-3 border-t border-steel bg-surface">
        {[
          { to: 30, suffix: "", label: "placówek" },
          { to: 300, suffix: "", label: "osób w zespole" },
          { to: 10000, suffix: " h", label: "pracy 1:1" },
        ].map((stat, i) => (
          <div
            key={stat.label}
            className={`px-4 py-6 sm:px-6 sm:py-8 md:px-10 md:py-9 ${i < 2 ? "border-r border-ink/10" : ""}`}
          >
            <CountUp
              to={stat.to}
              suffix={stat.suffix}
              className="stat-figure block whitespace-nowrap tabular-nums"
            />
            <span aria-hidden="true" className="stat-rule" />
            <span className="mt-3 block text-[0.6rem] uppercase leading-snug tracking-[0.14em] text-ink-soft sm:mt-4 sm:text-[0.68rem] sm:tracking-[0.18em]">
              {stat.label}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
